module.exports = __webpack_public_path__ + "assets/9deca505b3876ff2e61b93fcb48cce99.png";